import axios from 'axios'
import jwtDecode from 'jwt-decode'

import router from '../../router'
import {getResponseError} from "@/components/utils";

const API_URL = process.env.VUE_APP_API_URL + '/api/auth/'
const LOGIN_URL = API_URL + 'token/'
const USER_URL = process.env.VUE_APP_API_URL + '/api/users/'
const JWT_REFRESH_URL = API_URL + 'token/refresh/'
// const LOGOUT_URL = API_URL + 'logout/'

export default {
    namespaced: true,
    state: {
        isLoggedIn: !!localStorage.getItem('refreshToken'),
        user: JSON.parse(localStorage.getItem('authUser')),
        refresh: localStorage.getItem('refreshToken'),
        access: localStorage.getItem('accessToken')
    },
    getters: {
        isLoggedIn: state => state.isLoggedIn,
        isAdmin: state => state.user ? state.user.is_superuser : false,
        isExpired: (state) => () => {
            // FIXME: Hack Warning!!! For now call that getter as function.
            const token = jwtDecode(state.access)
            if (state.isLoggedIn) {
                if (Date.now() / 1000 >= token.exp - 1) {
                    return true
                }
                return false
            } else {
                return true
            }
        },
        isSessionExpired: (state) => () => {
            const token = jwtDecode(state.refresh)
            if (state.isLoggedIn) {
                if (Date.now() / 1000 >= token.exp - 1) {
                    return true
                }
                return false
            } else {
                return true
            }
        },
        username: state => state.user ? state.user.username : '',
        fullName: state => state.user ? (state.user.first_name + ' ' + state.user.last_name) : '',
        groups: state => state.user && state.user.groups_names ? state.user.groups_names : [],
        token: (state) => {
            return state.access
        },
        refreshExp: (state) => {
            const token = jwtDecode(state.refresh)
            return token.exp
        },
        accessExp: (state) => {
            const token = jwtDecode(state.access)
            return token.exp
        },
    },
    actions: {
        login({commit}, creds) {
            commit('LOGIN')
            return new Promise((resolve, reject) => {
                axios.post(LOGIN_URL, creds, {
                    withCredentials: true
                }).then(response => {
                    var refresh = response.data.refresh
                    localStorage.setItem('refreshToken', refresh)
                    var access = response.data.access
                    localStorage.setItem('accessToken', access)
                    let tokenDecoded = jwtDecode(refresh)
                    commit('LOGIN_SUCCESS')
                    // Set user
                    axios.get(USER_URL + tokenDecoded.user_id + '/',
                        {
                            headers: {
                                Authorization: 'JWT ' + access
                            }
                        })
                        .then((response) => {
                            let user = response.data
                            localStorage.setItem('authUser', JSON.stringify(user))
                            commit('SET_USER')
                        })
                    resolve()
                }).catch((e) => {
                    reject(getResponseError(e))
                })
            })
        },
        refresh({commit}) {
            return new Promise((resolve, reject) => {
                axios.post(JWT_REFRESH_URL, {
                    'refresh': localStorage.getItem('refreshToken')
                },).then(response => {
                    var access = response.data.access
                    localStorage.setItem('accessToken', access)
                    commit('LOGIN_REFRESH')
                    resolve()
                }).catch((e) => {
                    reject(getResponseError(e))
                })
            })
        },
        logout({commit}) {
            localStorage.removeItem('accessToken')
            localStorage.removeItem('refreshToken')
            commit('LOGOUT')
            commit('UNSET_USER')
            return new Promise(resolve => {
                resolve()
            })
        }
    },
    mutations: {
        'LOGIN': (state) => {
            state.pending = true
        },
        'LOGIN_SUCCESS': (state) => {
            state.isLoggedIn = true
            state.access = localStorage.getItem('accessToken')
            state.refresh = localStorage.getItem('refreshToken')
        },
        'LOGIN_REFRESH': (state) => {
            state.access = localStorage.getItem('accessToken')
        },
        'LOGOUT': (state) => {
            state.isLoggedIn = false
            router.push('/login').catch(() => {
            })
        },
        'SET_USER': (state) => {
            state.user = JSON.parse(localStorage.getItem('authUser'))
        },
        'UNSET_USER': (state) => {
            localStorage.removeItem('authUser')
            state.user = {}
        },
    }
}